import { useIsMobile, useIsLargeMobile } from './use-size-class';

/**
 * Custom hook to determine if header buttons should show full text or icon-only.
 * 
 * Prevents header buttons with long text from causing logo shrinkage by:
 * - Small/medium mobile (≤768px): Show icon only for main action buttons
 * - Desktop (>768px): Show full button text
 * 
 * This is particularly important for:
 * - Multilingual sites where translations may be longer (e.g., French)
 * - Buttons like "Find Your Home" / "Trouvez votre maison"
 * 
 * @returns Object with flags for button display modes
 */
export function useResponsiveHeaderButton() {
  const isMobile = useIsMobile();
  const isLargeMobile = useIsLargeMobile();

  // Show full button text only on desktop to prevent logo shrinkage
  const shouldShowFullButtonText = !isMobile;
  
  // Show icon-only button on mobile to save space
  const shouldShowIconOnly = isMobile;

  return {
    shouldShowFullButtonText,
    shouldShowIconOnly,
    isMobile,
    isLargeMobile,
  };
}

